/// <reference path="../bower_components/jquery/dist/jquery.js" />
function resetForm() {
    $('#siteContact').on('shown.bs.modal', function() {
        grecaptcha.reset(siteEnquiryCaptcha);
        $.getScript('https://www.google.com/jsapi', function()
        {
            google.load('maps', '3', {
                other_params: 'libraries=geometry,places&key=AIzaSyABiOJdCNb0rQsV949-xuT4igGEA-3X1fM', callback: function()
            {
                NZaddressAutocomplete();
            }});
        });
        $('#EnquiryRecaptchaResponse').val('');
        $('#Details').val('');
        $('#contact-message').val('');
        $('#siteContact .messageCaptchaFailed').addClass('hide');
        $('.site-contact-fields').removeClass('hide');
    });
}

function checkRecaptchaAndTerms() {
    $('#frmSiteContact .listing-button').click(function (e) {
        if (!$('#frmSiteContact #AgreeToTerms').is(':checked')) {
            e.preventDefault();
            $('#enquiryAgreeToTermsError').removeClass('hide');
        }

        if ($('#EnquiryRecaptchaResponse').val().length === 0) {
            e.preventDefault();
            $('#enquiryCaptchaError').removeClass('hide');
        }
        return $('#frmSiteContact').valid();
    });

    $('#frmSiteContact #AgreeToTerms').click(function () {
        if ($('#frmSiteContact #AgreeToTerms').is(':checked')) {
            $('#enquiryAgreeToTermsError').hide();
        } else {
            $('#enquiryAgreeToTermsError').show();
        }
    });
}

function submitSiteContactForm() {
    $('#frmSiteContact').submit(function (e) {
        if ($(this).valid()) {
            var data = $(this).serialize();
            $.post('/enquiry-api/submit', data)
                .success(function(data) {
                    if (data.EnquiryId !== 0) {
                        $('#siteContact').modal('hide');
                        if ($('input[name="EnquiryType"]:checked').val() === "MagazineSubscription")  {
                            document.cookie = "ModalShown=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/";
                        }
                        swal({
                            title: 'Message sent',
                            text: 'Thank you! Your message has been sent.',        
                            confirmButtonText: 'Ok',
                            confirmButtonClass: 'btn-info btn-outline',
                            type: 'success',
                            timer: 15000,
                            html: true
                        });
                    } else if (!data.RecaptchaValid) {
                        $('.site-contact-fields').addClass('hide');
                        $('#siteContact .messageCaptchaFailed').removeClass('hide');
                    }
                });
            e.preventDefault();
            return false;
        }
    });
}

function NZaddressAutocomplete() {
    $('.address-autocomplete').geocomplete({
        componentRestrictions: {
            country: 'nz'
        }
    }).bind('geocode:result', function(event, result){
        $('#Details').val( result.formatted_address );
    });
}

function enquiryType() {
    $('#frmSiteContact input[name="EnquiryType"]').change(function() {
        if ($('input[name="EnquiryType"]:checked').val() === 'EstimatedValueOfProperty') {
            $('.address-autocomplete').val('');
            $('#Details').val('');
            $('.site-enquiry .estimated-value-input').removeAttr('disabled').removeClass('hide');
            $('.site-enquiry .information-value-input, .site-enquiry .find-out-value-input').attr('disabled', 'disabled').addClass('hide');
            $('#contact-message-group').addClass('hide');
        } else if ($('input[name="EnquiryType"]:checked').val() === 'InformationAboutProperty') {
            $("#Details").val('');
            $('.site-enquiry .information-value-input').removeAttr('disabled').removeClass('hide');
            $('.site-enquiry .estimated-value-input, .site-enquiry .find-out-value-input').attr('disabled', 'disabled').addClass('hide');
            $('#contact-message-group').addClass('hide');
            $('.information-value-input').keyup(function() {
                $("#Details").val( this.value );
            });
        } else if ($('input[name="EnquiryType"]:checked').val() === 'FindOutSomethingElse') {
            $('#Details').val('');
            $('.site-enquiry .information-value-input, .site-enquiry .estimated-value-input').attr('disabled', 'disabled').addClass('hide');
            $('#contact-message-group').removeClass('hide');
            $('#contact-message').keyup(function() {
                $('#Details').val( this.value.replace(/\n/g, '') );
            });
        }
    });
}

function openForm() {
    $('button[data-target="#siteContact"], a[href*="#siteContact"]').click(function () {

        if (typeof $(this).data('personnelname') !== 'undefined') {
            $('#siteContact .modal-title').text('Contact ' + $(this).data('personnelname'));
        }

        if ((typeof $(this).data('personnelname') !== 'undefined') && (($(this).data('enquirytype') === 'agent') || ($(this).data('enquirytype') === 'team'))) {
            $('#siteContact .modal-title').text('Contact ' + $(this).data('personnelname'));
            if ((typeof $(this).data('listingid') !== 'undefined') && ($(this).data('listingid') !== 0)) {
                $('#siteContact .modal-title').text('Contact ' + $(this).data('personnelname') + ' about this listing');
            }
        }  else {
            $('#siteContact .modal-title').text('Contact us');
        }


        if ($(this).data('enquirytype') === "magazinesubscription") {
            $('#siteContact .modal-title').text("Sign up to receive a copy of Waterfront 2018/2019");
        }


        if ($(this).data('personnelid')) {
            $('.agent-enquiry #PersonnelId').removeAttr('disabled').val($(this).data('personnelid'));
        }

        if ($(this).data('teamemailaddress')) {
            $('.agent-enquiry #TeamEmailAddress').removeAttr('disabled').val($(this).data('teamemailaddress'));
        }

        if ($(this).data('enquirytype') === 'agent') {
            $("#Agent").prop("checked", true);
            if ($(this).data('listingid') !== undefined && $(this).data('listingid') >= 0)
                $('.agent-enquiry #ListingId').val($(this).data('listingid')).removeAttr('disabled');
            else
                $('.agent-enquiry #ListingId').val('').attr('disabled', 'disabled');

            $('.site-enquiry').addClass('hide');
            $('#contact-message-group').removeClass('hide');
            $('#contact-address-group').addClass('hide');
            $('#contact-message').keyup(function () {
                $('#Details').val(this.value.replace(/\n/g, ''));
            });
        } else if ($(this).data('enquirytype') === 'team') {
                $("#Team").prop("checked", true);
                if ($(this).data('listingid') !== undefined && $(this).data('listingid') >= 0)
                    $('.agent-enquiry #ListingId').val($(this).data('listingid')).removeAttr('disabled');
                else
                    $('.agent-enquiry #ListingId').val('').attr('disabled', 'disabled');

                $('.site-enquiry').addClass('hide');
                $('#contact-message-group').removeClass('hide');
                $('#contact-address-group').addClass('hide');
                $('#contact-message').keyup(function () {
                    $('#Details').val(this.value.replace(/\n/g, ''));
                });
        } else if ($(this).data('enquirytype') === 'magazinesubscription') {
            $("#Magazine").prop("checked", true);
            $('.agent-enquiry #ListingId').val('').attr('disabled', 'disabled');
            $('.agent-enquiry #PersonnelId').val('').attr('disabled', 'disabled');
            $('#phone-group').addClass('hide');
            $('#Phone').val('0000000');
            $('.site-enquiry').addClass('hide');
            $('#contact-message-group').addClass('hide');
            $('#contact-address-group').removeClass('hide');     
            $('#contact-address').keyup(function () {
                $('#Details').val(this.value.replace(/\n/g, ''));
            });
        } else {
            $('.agent-enquiry #ListingId').val('').attr('disabled', 'disabled');
            $('.agent-enquiry #PersonnelId').val('').attr('disabled', 'disabled');
            $('.site-enquiry').removeClass('hide');
            $('#contact-message-group').addClass('hide');
            $('.site-enquiry .estimated-value-input').removeAttr('disabled').removeClass('hide');
            $('input[name = "EnquiryType"][value="EstimatedValueOfProperty"]').prop('checked', true);
            $('.site-enquiry .information-value-input, .site-enquiry .find-out-value-input').attr('disabled', 'disabled').addClass('hide');
            $('.site-enquiry .information-value-input, .site-enquiry .find-out-value-input').addClass('hide');
        }
    });
}

function initializeEnquiryForm() {
    resetForm(); //Empty values and hide error or succes messages
    openForm(); //Initialice form from button or anchor data attributes
    checkRecaptchaAndTerms(); //Stop form from being submitted if reCaptcha fails
    //NZaddressAutocomplete(); //Make input with class address-autocomplete use Google address autocomplete for New Zealand
    enquiryType(); //Show / Hide input fields depending of enquiry type
    submitSiteContactForm();//Ajax request to submit form
}
